import React from 'react'

const RevenuePage = () => {
  return (
    <div style={{flex:1 , justifyContent: 'center', alignItems: 'center', marginTop: '30rem'}}>
        <p>Coming Soon</p>
    </div>
  )
}

export default RevenuePage